<template>
 <SemanaCalendario/>
</template>

<script>
// @ is an alias to /src
import SemanaCalendario from '../components/SemanaCalendario.vue'

export default {
  name: 'HomeView',
  components: {
    SemanaCalendario
  }
}
</script>
